import { takeLatest } from "redux-saga/effects";
import actions from "../../constants/roHubAccessActions";
import { getRestrictedHubsWorker } from "../../workers/roHubAccessWorker/roHubAccessWorker";

export function* getRestrictedHubsWatcher() {
  yield takeLatest(actions.GET_RESTRICTED_HUBS, getRestrictedHubsWorker);
}
